import React from "react";
import { MapContext } from "react-map-gl";
import { Switch, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import themeConfig from "./MUIThemeConfig";
import Home from "./pages/Home";
import RegionalMap from "./pages/RegionalMap";
import ModellerInterfacePage from "./pages/ModellerInterface";
import { PAGES } from "./constants/constants";


// Create a Material-UI theme using the theme configuration
const theme = createTheme(themeConfig);

/**
 * The main application component responsible for routing and rendering different pages.
 * @category App
 * @component
 * @returns {JSX.Element} The rendered application.
 */
const App = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <MapContext.Provider>
          <div>
            <Switch>
              <Route exact path="/">
                {/* Renders the Home component within a LoadScreen. */}
                <Home />
              </Route>
              {PAGES.map((page) => (
                <Route exact path={page.path} key={page.name}>
                  <RegionalMap />
                </Route>
              ))}

              {process.env.NODE_ENV === "development" &&
                PAGES.map((page) => (
                  <Route exact path={page.modellerPath} key={page.name}>
                    {/* Renders the ModellerInterface component within an AppProvider, with a hidden Map component. */}
                    <ModellerInterfacePage />
                  </Route>
                ))}
            </Switch>
          </div>
        </MapContext.Provider>
      </ThemeProvider>
    </>
  );
};

export default App;
